import React, { useState, useEffect } from "react";
import moment from "moment";
import { Line, Bar } from "react-chartjs-2";
import FETCH from "../../../utils/fetch";
import "../LiabilityDashboard.css";
import debtImage from "../../../assets/images/debt.png";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import { ChartColors } from "../../../components/ChartColors";
export const LiabilityReport = (props) => {
  const [monthlyPayment, setMonthlyPayment] = useState([]);

  const uniqueModules = [
    ...new Set(
      props.liabilitiesCredit &&
        props.liabilitiesCredit.map(
          (data) =>
            data["Nickname of Liabilities"] || data["Nickname of Credit"]
        )
    ),
  ];
  const nicknames =
    props.liabilitiesCredit &&
    props.liabilitiesCredit.map(
      (card) =>
        card["Nickname of Liabilities"] || card["Nickname of Credit"] || null
    );

  // const data = props.liabilitiesCredit && props.liabilitiesCredit.map(data => {
  //   const initialLoanAmount = +data["Initial Loan Amount"] || 0;
  //   const creditBalance = +data["Credit Balance"] || 0;
  //   return initialLoanAmount || creditBalance || 0;
  // });
  // const uniqueModules = [
  //   ...new Set(
  //     (props.liabilitiesCredit || []).filter(data => data.subType === "Liability").map(
  //       data => data["Nickname of Liabilities"] || null
  //     )
  //   )
  // ];
  const valueTotal = props.liabilitiesCredit.reduce(
    (sum, item) => sum + item["Monthly Payment"],
    0
  );

  useEffect(() => {
    // this is for Bar chart
    const barSeries = [
      {
        label: "Module",
        // data: (props.liabilitiesCredit && props.liabilitiesCredit).map(data => {
        //   if (data.subType === "Liability") {
        //     return ((+data["Initial Loan Amount"] || 0) || (+data["Credit Balance"] || 0));
        //   } else {
        //     return 0;
        //   }
        // }),
        data:
          props.liabilitiesCredit &&
          props.liabilitiesCredit.map(
            (data) =>
              +data["Loan Balance"] || +data["Initial Loan Amount"] ||
              0 ||
              +data["Credit Balance"] ||
              0 ||
              0
          ),
        fill: false,
        backgroundColor:
          props.liabilitiesCredit &&
          props.liabilitiesCredit.map(
            (_, index) => ChartColors[index % ChartColors.length] // Cycle through ChartColors using modulus
          ),
        borderColor:
          props.liabilitiesCredit &&
          props.liabilitiesCredit.map(
            (_, index) => ChartColors[index % ChartColors.length] // Same for borderColor
          ),
        // backgroundColor: Array.from(
        //   { length: nicknames.length },
        //   () => "#" + Math.floor(Math.random() * 16777215).toString(16)
        // ),
        // borderColor: Array.from(
        //   { length: nicknames.length },
        //   () => "#" + Math.floor(Math.random() * 16777215).toString(16)
        // ),
      },
    ];
    console.log("series2 bar", barSeries);
    setMonthlyPayment(barSeries);
  }, [props.liabilitiesCredit]);

  console.log("logo uniqueModules", monthlyPayment, uniqueModules);
  const data2 = {
    labels: nicknames && nicknames,
    // labels: ["All Modules"],
    datasets: monthlyPayment && monthlyPayment,
  };

  return (
    <React.Fragment>
      <div className="liabiltyCard1">
        <h3 className="Reportheading">Liabilities and Credit Report</h3>
        <div className="liabilityRow">
          <div className="liliability-image-and-amount-container">
            <img src={debtImage} alt="" />
            <div className="liliability-amounts-container">
              <div style={{ display: "flex", gap: "2rem" }}>
                <div>
                  <h3>Loans</h3>
                  <h2>
                    $
                    {props.totalLoan &&
                      parseFloat(props.totalLoan)
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </h2>
                </div>
                <div>
                  <h3>Credit Cards/HELOC</h3>
                  <h2>
                    $
                    {props.totalBalance &&
                      parseFloat(props.totalBalance)
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </h2>
                </div>
              </div>
              <div>
                <h1>Total</h1>
                <h1>
                  $
                  {(props.totalLoan ||
                    props.totalBalance) &&
                    (parseFloat(props.totalLoan) + parseFloat(props.totalBalance))
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                </h1>

                {/*<h1>${props.totalBalance && props.totalLoan && (props.totalBalance+props.totalLoan).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</h1>*/}
              </div>
            </div>
          </div>
          <div>
            <div className="reportrow">
              <div className="reportrowData">
                <span className="reportTitle"> Client Name</span>
                <span className="reportsubTitle">
                  {" "}
                  {localStorage.getItem("User") ? (
                    localStorage.getItem("User")
                  ) : (
                    <React.Fragment></React.Fragment>
                  )}
                </span>
              </div>
            </div>
            <div className="reportrow2">
              <div className="reportrowData">
                <span className="reportTitle"> Today's Date </span>
                <span className="reportsubTitle">
                  {" "}
                  {moment().format("MM/DD/YYYY")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="liabiltyCard2" style={{ position: "relative" }}>
        <h1 className="liablitycardheading">Balance</h1>
        <div style={{ marginTop: "1rem", display: "flex" }}>
          <Bar
            data={data2}
            height={300}
            options={{
              legend: {
                display: false,
              },

              maintainAspectRatio: false,
              responsive: true,
              scales: {
                xAxes: [
                  {
                    gridLines: {
                      color: "rgba(0, 0, 0, 0)",
                    },
                  },
                ],
                yAxes: [
                  {
                    ticks: {
                      callback: function (value) {
                        return new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(value);
                      },
                    },
                  },
                ],
              },

              // plugins: {
              //   legend: {
              //     position: "top",
              //   },
              //   title: {
              //     display: true,
              //     text: "Goals",
              //   },
              // },
            }}
          />
        </div>
        <NewLoader isLoading={props.loading} />
      </div>
    </React.Fragment>
  );
};
